import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RelationGeography, RelationGeographyInner } from '../../../../swagger-api';
import { PieChartData } from '../../../shared/pie-chart/pie-chart.component';
import { calculateRelationsCount } from '../../services/relation-shared.service';

interface PieCalculations {
  labels: string[];
  data: number[];
}

@Component({
  selector: 'app-relation-geography',
  templateUrl: './relation-geography.component.html',
  styleUrls: ['./relation-geography.component.scss'],
})
export class RelationGeographyComponent implements OnChanges {
  @Input({ required: true }) public relationType: string;
  @Input({ required: true }) public relationGeography: RelationGeography;

  @Input({ required: true }) public noRelationEntitiesLabel: string;
  @Input({ required: true }) public dataTestIdSuffix: string;

  public pieChartData: PieChartData;
  public relationsCount = 0;

  public othersThreshold = 12;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['relationGeography'] && !changes['relationGeography'].firstChange) {
      this.relationsCount = calculateRelationsCount(this.relationGeography);
      this.pieChartData = this.calculateChartData(this.relationGeography);
    }
  }

  private calculateChartData(relationGeography: RelationGeography): PieCalculations {
    const labels: string[] = [];
    const data: number[] = [];

    const piePartsAmount = relationGeography.length > this.othersThreshold ? 11 : 12;
    const countriesGeography: RelationGeography = relationGeography.slice(0, piePartsAmount);
    countriesGeography.forEach((relationGeography: RelationGeographyInner) => {
      const percentage: number = this.calculatePiePercentage(relationGeography.count);
      labels.push(`${relationGeography.name} ${percentage}%`);
      data.push(relationGeography.count);
    });

    const otherCountriesGeography: RelationGeography = relationGeography.slice(piePartsAmount);
    if (countriesGeography.length > 0 && otherCountriesGeography.length > 0) {
      const sum: number = otherCountriesGeography.reduce((acc, curr) => acc + curr.count, 0);
      const percentage: number = this.calculatePiePercentage(sum);

      labels.push(`Others: ${percentage}%`);
      data.push(sum);
    }

    return { labels, data };
  }

  private calculatePiePercentage(count: number): number {
    return Math.round((count / this.relationsCount) * 100 * 10) / 10;
  }
}
